import React from "react";
import ProjectForms from "./ProjectForms";
export default function CreateProject() {
    return (
        <ProjectForms title="Create New Project" />
    );
}
